import React from 'react';
import Login from './auth/Login';

const Home = () => {
  return (
    <div><Login /></div>
  )
}

export default Home;